export default __webpack_public_path__ + "static/expert-assistance-large-b08eb50cf996e32de6c76f2a683f76f1.jpg";